/**
 * The phone's Add forms' own words (piece 35, batch MA2; decisions 4201, 4220),
 * spread into the one string lookup beside the first release's words. A word
 * the web already says, such as Save, Cancel, Keep both or the duplicate
 * window's sentences, is read from the web's own key and is not repeated here.
 */
export const ADD_RECORD_STRINGS = {
  'mobile.add.add': 'Add',
  'mobile.add.contact': 'Add Contact',
  'mobile.add.openIt': 'Open It',
  'mobile.add.change': 'Change',
  'mobile.add.unreachable': 'The server did not answer, so nothing was saved. Check the connection, then press Retry.',
  'mobile.add.employerHint': 'Leave the company empty to add the person without an employer.',
  'mobile.form.choose': 'Choose',
  'mobile.form.details': 'Details',
  'mobile.form.work': 'Work',
  'mobile.form.when': 'When',
  'mobile.form.logContact': 'Log Contact',
} as const;
